/* eslint-disable eqeqeq */
import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useLayoutEffect,
} from "react";
import { Context } from "../../utils/store";
import axios from "../../utils/axios";
import Button from "../../components/Button";
import { InputForm } from "../../components/Input";
import AnimateHeight from "react-animate-height";
import { VscChevronDown, VscChevronUp } from "react-icons/vsc";
import DayBlock from "../../components/DayBlock";
import Swal from "sweetalert2";
import CreditCardInput from "react-credit-card-input";
import Quotes from "../../assets/icons/Quotes.png";
import { useCookies } from "react-cookie";
import CheckBox from "../../components/CheckBox";
import { useHistory } from "react-router";
import Geocode from "react-geocode";
import InfoMsg from "../../components/InfoMsg";
import InfoCircle from "../../components/InfoCircle";
import "../../css/styles.css";
import { Mixpanel } from "../../Mixpanel";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
Geocode.setApiKey("AIzaSyAsbMyV_d9VDkvEdeY4jgkYpbp4sN9dnoo");

// set response language. Defaults to english.
Geocode.setLanguage("en");

// set response region. Its optional.
// A Geocoding request with region=es (Spain) will return the Spanish city.
Geocode.setRegion("us");

// Enable or disable logs. Its optional.
Geocode.enableDebug();

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 5000,
});

interface SummaryItem {
  label: string;
  quantity: number;
  amountPerDay: number;
  totalAmount: number;
}
export default function Checkout(props: any) {
  const { state, dispatch } = useContext(Context);
  const [cookies, setCookie] = useCookies();
  const history = useHistory();
  const [height, setHeight] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isTransactionFeesInfo, setIsTransactionFeesInfo] = useState(false);
  function cookieHandler(name: string, value: any) {
    setCookie(name, value);
  }

  const toggleScheduleView = () => {
    height === 0 ? setHeight("auto") : setHeight(0);
  };
  const [email, setEmail] = React.useState("");
  const [confirmEmail, setConfirmEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [phoneLength, setPhoneLength] = React.useState("");
  const [formattedPhone, setFormattedPhone] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [city, setCity] = React.useState("");
  const [stateValue, setStateValue] = React.useState("");
  const [zipCode, setZipCode] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [summaryItems, setSummaryItems] = React.useState<any>([]);
  const [isZakat, setIsZakat] = React.useState(true);
  const [consent, setIsConsent] = React.useState(true);
  const [isTermsAndPrivacy, setIsTermsAndPrivacy] = React.useState(true);
  const [coverTransactionFee, setTransactionFeeStatus] = React.useState(true);
  const [coverFee, setCoverFee] = React.useState(0.0);
  const [islamicDaysQuantity, setIslamicDaysQuantity] = React.useState(0);
  const [personalDaysQuantity, setPersonalDaysQuantity] = React.useState(0);
  const [otherDaysQuantity, setOtherDaysQuantity] = React.useState(0);
  const [currentStripeToken, setCurrentStripeToken] = React.useState(null);

  const [cards, setCards] = useState([]);
  const [cardNumber, setCardNumber] = React.useState("");
  const [cardExpiry, setCardExpiry] = React.useState("");
  const [cardCVC, setCardCVC] = React.useState("");
  const [cardValidity, setCardValidity] = React.useState("");
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [showEmailExists, setShowEmailExists] = useState(false);
  const [inputHeight, setInputHeight] = useState(0);
  const [disableButton, setDisableButton] = useState(false);

  const [islamicDaysCount, setIslamicDaysCount] = useState(0);
  const [personalDaysCount, setPersonalDaysCount] = useState(0);
  const [otherDaysCount, setOtherDaysCount] = useState(0);

  const ref: any = useRef(null);

  useLayoutEffect(() => {
    //console.log("height", ref?.current?.clientHeight);
    const updateSize = () => {
      setInputHeight(ref?.current?.clientHeight);
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  });

  useEffect(() => {
    const selectedIslamicDays = state.firstTimeInfo?.islamicDays?.filter(
      (islamicDay: { isIslamicDaySelected: boolean }) =>
        islamicDay.isIslamicDaySelected
    ).length;

    const selectedPersonalDays = state.firstTimeInfo?.personalDays?.filter(
      (personalDay: { date?: object }) =>
        personalDay.date && personalDay.isPersonalDayActive
    ).length;

    const selectedOtherDays = state.firstTimeInfo?.otherDays?.filter(
      (otherDay: { isSelected: boolean }) => otherDay.isSelected
    ).length;

    if (
      selectedIslamicDays === 0 &&
      selectedPersonalDays === 0 &&
      selectedOtherDays === 0
    ) {
      setDisableButton(true);
    }

    setIslamicDaysCount(selectedIslamicDays);
    setPersonalDaysCount(selectedPersonalDays);
    setOtherDaysCount(selectedOtherDays);
  }, [
    state.firstTimeInfo.islamicDays,
    state.firstTimeInfo.personalDays,
    state.firstTimeInfo.otherDays,
  ]);

  useEffect(() => {
    if (!state.isLoggedIn && state?.signupInfo !== null) {
      setEmail(state?.signupInfo?.email);
      setConfirmEmail(state?.signupInfo?.confirmEmail);
      setPhone(state?.signupInfo?.phone);
      setPhoneLength(state?.signupInfo?.phone?.length);
      setFirstName(state?.signupInfo?.firstName);
      setLastName(state?.signupInfo?.lastName);
      setAddress(state?.signupInfo?.address);
      setCity(state?.signupInfo?.city);
      setStateValue(state?.signupInfo?.stateValue);
      setZipCode(state?.signupInfo?.zipCode);
      setCountry(state?.signupInfo?.country);
    }

    axios
      .get("/config-settings")
      .then((response) => {
        dispatch({
          type: "firstTimeInfo",
          firstTimeInfo: {
            ...state.firstTimeInfo,
            coverFee: response.data.response.TRANSACTION_FEE,
            minDonation: response.data.response.MIN_DONATION_AMOUNT,
          },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const updateSignupInfo = (lable, value) => {
    if (!state.isLoggedIn) {
      dispatch({
        type: "signupInfo",
        signupInfo: {
          ...state.signupInfo,
          [lable]: value,
        },
      });
    }
  };

  const updateAddress = () => {
    dispatch({
      type: "signupInfo",
      signupInfo: {
        ...state.signupInfo,
        address: address,
        stateValue: stateValue,
        city: city,
        country: country,
        zipCode: zipCode,
      },
    });
  };

  useEffect(() => {
    if (!state.isLoggedIn) {
      updateAddress();
    }
  }, [address, stateValue, city, country, zipCode]);

  const initialFormErrors = {
    errorCounter: 0,
    firstName: null,
    lastName: null,
    email: null,
    confirmEmail: null,
    phone: null,
    password: null,
    confirmPassword: null,
    name: null,
    address: null,
    city: null,
    stateValue: null,
    zipCode: null,
    country: null,
    cardError: null,
  };
  const [formErrors, setFormErrors] = React.useState(initialFormErrors);

  const [predictions, setPredictions] = useState([]);

  const googleAutocomplete = async (text: string) =>
    new Promise((resolve, reject) => {
      if (!text) {
        return reject("Need valid text input");
      }

      // for use in things like GatsbyJS where the html is generated first
      if (typeof window === "undefined") {
        return reject("Need valid window object");
      }

      try {
        new window.google.maps.places.AutocompleteService().getPlacePredictions(
          { input: text, componentRestrictions: { country: "us" } },
          resolve
        );
      } catch (e) {
        reject(e);
      }
    });

  const handleAddressSearch = async (text: string, keyCode: any) => {
    setAddress(text);
    const handleDebounce = setTimeout(async () => {
      try {
        if (text.length < 2) {
          setPredictions([]);
          return;
        }
        const nextPredictions = await googleAutocomplete(text);
        setPredictions(nextPredictions);
      } catch (e) {
        console.error(e);
      }
    }, 400);

    return () => {
      clearTimeout(handleDebounce);
    };
  };

  const handlePredictionSelection = (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.KeyboardEvent<HTMLButtonElement>,
    prediction: null
  ) => {
    e.preventDefault();
    Geocode.fromAddress(prediction.description).then(
      (response: any) => {
        if (response.results[0].address_components) {
          response.results[0].address_components.forEach((address: any) => {
            for (var j = 0; j < address.types.length; j++) {
              if (address.types[j] == "postal_code") {
                setZipCode(address.long_name);
              }
              if (address.types[j] == "country") {
                setCountry(address.long_name);
              }
              if (address.types[j] == "administrative_area_level_1") {
                setStateValue(address.short_name);
              }
              if (
                address.types[j] == "locality" ||
                address.types[j] == "sublocality"
              ) {
                setCity(address.long_name);
              }
            }
          });
        }

        // console.log("geocode", response);
      },
      (error: any) => {
        console.error("error", error);
      }
    );
    if (prediction !== null) {
      setAddress(prediction.structured_formatting.main_text);
      setPredictions([]);
    }
  };

  const scheduleDontation = async () => {
    Mixpanel.track("Submit Checkout Form");
    setLoading(true);
    if (!consent || !isTermsAndPrivacy) {
      Toast.fire({
        title:
          "Acceptance of the CharityMoments Terms and Conditions and Privacy Policy is required.",
        icon: "error",
      });
      setLoading(false);
      return;
    }

    // if (
    //   !state.firstTimeInfo.islamicDays &&
    //   !state.firstTimeInfo.personalDays &&
    //   !state.firstTimeInfo.otherDays
    // ) {
    //   Mixpanel.track("Checkout Form Failed");
    //   setLoading(false);
    //   Toast.fire({
    //     title: "No contributions to make !",
    //     icon: "error",
    //   });
    //   // return a message no contributions to make
    //   return;
    // }

    if (
      islamicDaysCount === 0 &&
      personalDaysCount === 0 &&
      otherDaysCount === 0
    ) {
      Mixpanel.track("Checkout Form Failed");
      setLoading(false);
      Toast.fire({
        title: "No contributions to make !",
        icon: "error",
      });
      // return a message no contributions to make
      return;
    }

    if (!state.firstTimeInfo.causesContributions) {
      setLoading(false);
      //Mixpanel.track("Checkout Form Failed");
      Toast.fire({
        title: "No causes contributions found !",
        icon: "error",
      });
      // no causes contributions found
      return;
    }
    if (state.firstTimeInfo.donationTotal <= 0) {
      setLoading(false);
      Mixpanel.track("Checkout Form Failed");
      Toast.fire({
        title: "No contributions amount found !",
        icon: "error",
      });
      // no causes contributions found
      return;
    }
    // if (selectedCardId == null) {
    //   setLoading(false);
    //   Mixpanel.track("Checkout Form Failed");
    //   Toast.fire({
    //     title: "Payment method is required!",
    //     icon: "error",
    //   });
    //   // no causes contributions found
    //   return;
    // }
    if (!validate()) {
      Mixpanel.track("Checkout Form Failed");
      setLoading(false);
      // Toast.fire({
      //   title: "Please fill the form correctly !",
      //   icon: "error",
      // });
      console.log(formErrors);
      return;
    }
    try {
      let user = null;
      if (!state.isLoggedIn) {
        user = await signupUser();
      } else {
        user = state.userInfo;
      }

      const personalDays = state.firstTimeInfo.personalDays
        ? state.firstTimeInfo.personalDays.filter(
            (personalDay: { date?: object }) => personalDay.date
          )
        : [];

      const islamicDays = state.firstTimeInfo.islamicDays
        ? state.firstTimeInfo.islamicDays.filter(
            (islamicDay: { isIslamicDaySelected: boolean }) =>
              islamicDay.isIslamicDaySelected
          )
        : [];

      const otherDays: any = state.firstTimeInfo.otherDays
        ? state.firstTimeInfo.otherDays.filter(
            (otherDays: { isSelected: boolean }) => otherDays.isSelected
          )
        : [];

      const selectedCharities = state.firstTimeInfo.charities
        .filter(
          (charity: { isSelected: any; isActive: any }) =>
            charity.isActive && charity.isSelected
        )
        .map((charity: { _id: any }) => charity._id);
      const selectedContributions =
        state.firstTimeInfo.causesContributions.filter(
          (contribution: { amount: any }) => contribution.amount
        );
      const donationSchedule = {
        userId: user?.id ? user?.id : user._id,
        scheduleType: state.firstTimeInfo.donationFreq,
        scheduleStartDate: new Date().toISOString(),
        frequency: state.firstTimeInfo.donationFreq,
        stripeCardToken: user?.stripeToken,
        stripeCardId: state.isLoggedIn ? selectedCardId : null,
        isZakat,
        coverTransactionFee,
        personalDays: getDonationDays(personalDays, "personalDays"),
        islamicDays: getDonationDays(islamicDays, "islamicDays"),
        otherDays: getDonationDays(otherDays, "otherDays"),
        charities: selectedCharities,
        contributions: selectedContributions,
        totalDonationAmount: state?.firstTimeInfo?.donationTotal,
        processingfee: coverFee,
        processSchedule: state.isLoggedIn ? true : false,
      };

      // TODO:call donation schedule api here.
      await axios({
        method: "post",
        url: "/donationschedule",
        data: donationSchedule,
      })
        .then(async (response: any) => {
          Mixpanel.track("Checkout Successful", donationSchedule);
          setLoading(false);
          //  return response.data.id;
          history.push("/thankyou");
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          Mixpanel.track("Checkout Form Failed");
          Toast.fire({
            title: err.message,
            icon: "error",
          });
        });
    } catch (err) {
      console.log(err);
      setLoading(false);
      Mixpanel.track("Checkout Form Failed");
      Toast.fire({
        title: "Something went wrong !",
        icon: "error",
      });
      // TODO: display error here
    }
  };
  const getDonationDays = (days: Array<any>, daysType: string) => {
    const amountPerDay = dynamicSum({
      data: state.firstTimeInfo.causesContributions,
      sumKey: "amount",
    });
    let newDays: {
      id: any;
      name: any;
      date?: any;
      donationAmt: number;
      processingfee: number;
      dayOfMonth?: any;
      manualEntryText?: any;
      startFrom: string;
      isProcessed: boolean;
      notificationDate?: any;
      islamicMonthId?: any;
      isNight?: any;
    }[] = [];

    days.forEach((day) => {
      let newDay;
      if (daysType == "personalDays" && day.isPersonalDayActive) {
        newDay = {
          id: day._id,
          name: day.name,
          date: day.date ? day.date : day.calendarDate,
          donationAmt: amountPerDay,
          processingfee: coverFee,
          dayOfMonth: day.dayOfMonth ? day.dayOfMonth : null,
          manualEntryText: day.manualEntryText ? day.manualEntryText : null,
          startFrom: new Date().toISOString(),
          isProcessed: false,
        };
        newDays.push(newDay);
      } else if (daysType === "islamicDays") {
        newDay = {
          id: day._id,
          name: day.name,
          date: day.date ? day.date : day.calendarDate,
          notificationDate: day.notificationDate,
          donationAmt: amountPerDay,
          processingfee: coverFee,
          dayOfMonth: day.dayOfMonth ? day.dayOfMonth : null,
          islamicMonthId: day.islamicMonthId,
          startFrom: new Date().toISOString(),
          isProcessed: false,
          isNight: day.isNight ? day.isNight : false,
        };
        newDays.push(newDay);
      } else if (daysType == "otherDays" && day.isSelected) {
        newDay = {
          id: day._id,
          name: day.name,
          donationAmt: amountPerDay,
          processingfee: coverFee,
          startFrom: new Date().toISOString(),
          isProcessed: false,
        };
        newDays.push(newDay);
      }
    });

    return newDays;
  };

  const creataCardToken = async (number: any, cvc: string, expiry: string) => {
    // console.log(expiry.substring(5, 7));
    const params = new URLSearchParams();
    params.append("card[number]", number);
    params.append("card[exp_month]", expiry.substring(0, 2));
    params.append("card[exp_year]", expiry.substring(5, 7));
    params.append("card[cvc]", cvc);
    params.append("card[name]", firstName + " " + lastName);
    params.append("card[address_line1]", address);
    params.append("card[address_city]", city);
    params.append("card[address_state]", stateValue);
    params.append("card[address_zip]", zipCode);
    params.append("card[address_country]", country);
    return new Promise(async (resolve, reject) => {
      await axios({
        method: "post",
        url: "https://api.stripe.com/v1/tokens",
        headers: {
          Authorization:
            "Bearer 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",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        params,
      })
        .then(async (response: any) => {
          // cookieHandler("tokenId", response.data.id);
          resolve(response.data.id);
        })
        .catch((err) => {
          setLoading(false);
          setCardValidity("notvalid");
          // Toast.fire({
          //   title: "Card is not valid",
          //   icon: "error",
          // });
        });
    });
  };

  const signupUser = async () => {
    // TODO: verify user card details here.
    Mixpanel.track("User Registration Started");
    let cardNumberValue = null;
    let cardExpiryValue = null;
    let cardCVCValue = null;
    cards.forEach((oneCard: any) => {
      if (oneCard.id === selectedCardId || cards.length > 1) {
        cardNumberValue = oneCard.card.cardNumber;
        cardExpiryValue = oneCard.card.cardExpiry;
        cardCVCValue = oneCard.card.cardCVC;
      } else if (cards.length === 1) {
        cardNumberValue = oneCard.card.cardNumber;
        cardExpiryValue = oneCard.card.cardExpiry;
        cardCVCValue = oneCard.card.cardCVC;
      }
    });

    const stripeToken: any = await creataCardToken(
      cardNumberValue,
      cardCVCValue,
      cardExpiryValue
    );
    setCurrentStripeToken(stripeToken);

    if (firstName && lastName && email && address && country && zipCode) {
      const userInfo = {
        firstName,
        lastName,
        email,
        phone,
        password,
        address,
        city,
        state: stateValue,
        country,
        zipCode,
        stripeToken,
        userType: "customer",
        mfaEnabled: false,
      };
      return new Promise(async (resolve, reject) => {
        await axios({
          method: "post",
          url: "/register",
          data: userInfo,
        })
          .then(async (response: any) => {
            Mixpanel.track("User Registration Complete", {
              firstName: firstName,
              lastName: lastName,
              email: email,
              phone: phone,
              type: "customer",
            });

            Mixpanel.alias(email);
            Mixpanel.identify(email);
            Mixpanel.people.set({
              $first_name: firstName,
              $name: firstName + " " + lastName,
              $email: email,
              phone: phone,
              type: "customer",
            });

            // cookieHandler("cookie", response.data.cookie);
            // dispatch({
            //   type: "isLoggedIn",
            //   isLoggedIn: true,
            // });

            resolve(response.data.response);
          })
          .catch((err) => {
            console.log(err.response);
            Toast.fire({
              title: err.response?.data.response.message
                ? err.response?.data.response.message
                : err.response?.data.message
                ? err.response?.data.message
                : "Something went wrong. Please try again later",
              icon: "error",
            });
          });
        setLoading(false);
      });
      // TODO: create user here.
      // return userInfo;
    } else {
      Toast.fire({
        title: "Please fill all the details in the form",
        icon: "error",
      });
    }
  };

  const getSummaryItems = () => {
    const summary: Array<SummaryItem> = [];

    let amountPerDay;
    if (state.firstTimeInfo.causesContributions) {
      amountPerDay = dynamicSum({
        data: state.firstTimeInfo.causesContributions,
        sumKey: "amount",
      });
    }

    if (state.firstTimeInfo.islamicDays) {
      const quantity = islamicDaysCount;
      setIslamicDaysQuantity(quantity);
      summary.push({
        label: "Islamic Days",
        quantity,
        amountPerDay,
        totalAmount: amountPerDay * quantity,
      });
    } else if (!state.firstTimeInfo.islamicDays) {
      summary.push({
        label: "Islamic Days",
        quantity: 0,
        amountPerDay: 0,
        totalAmount: 0,
      });
    }

    if (state.firstTimeInfo.personalDays) {
      const quantity = personalDaysCount;
      summary.push({
        label: "Personal Days",
        quantity,
        amountPerDay,
        totalAmount: quantity * amountPerDay,
      });
      setPersonalDaysQuantity(quantity);
    } else if (!state.firstTimeInfo.personalDays) {
      summary.push({
        label: "Personal Days",
        quantity: 0,
        amountPerDay: 0,
        totalAmount: 0,
      });
    }

    if (state.firstTimeInfo.otherDays) {
      let quantity = otherDaysCount;

      summary.push({
        label: "Sunnah Days",
        quantity,
        amountPerDay,
        totalAmount: quantity * amountPerDay,
      });
      setOtherDaysQuantity(quantity);
    } else if (!state.firstTimeInfo.otherDays) {
      summary.push({
        label: "Sunnah Days",
        quantity: 0,
        amountPerDay: 0,
        totalAmount: 0,
      });
    }

    const totalSum = dynamicSum({ data: summary, sumKey: "totalAmount" });
    setCoverFee(
      state?.firstTimeInfo?.donationTotal * state.firstTimeInfo.coverFee
    );

    setSummaryItems(summary);
  };

  const fetchAndSetCreditCards = async () => {
    await axios({
      method: "POST",
      url: "/paymentmethod",
      headers: {
        Authorization: `Bearer ${cookies.tokenId}`,
      },
    })
      .then((response) => {
        let newCards = [...response.data.response];
        let customer = response.data.customer;
        setSelectedCardId(customer.default_source);
        state?.firstTimeInfo?.addedNewCreditCards?.forEach(
          (addedNewCard: any) => {
            newCards.unshift(addedNewCard);
          }
        );
        setCards(newCards);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // get user details from global state and
  // set it to checkout form
  const getUserDetails = () => {
    // console.log('user info in state', state.userInfo);
    if (state.userInfo) {
      setEmail(state.userInfo.email);
      setPhone(state.userInfo.phone);
      if (state.userInfo.phone) {
        setPhoneLength(state?.userInfo?.phone?.length);
      }
      setFirstName(state.userInfo.firstName);
      setLastName(state.userInfo.lastName);
      setAddress(state.userInfo.address);
      setCity(state.userInfo.city);
      setStateValue(state.userInfo.state);
      setZipCode(state.userInfo.zipCode);
      setCountry(state.userInfo.country);
      fetchAndSetCreditCards();

      // TODO: credit card number and address are left, set it here
    }
  };

  useEffect(() => {
    getSummaryItems();
    if (state.isLoggedIn) {
      getUserDetails();
    } else {
      if (cards.length == 0) {
        addNewCreditCard();
      }
    }
  }, [state]);

  useEffect(() => {
    getSummaryItems();
  }, [islamicDaysCount, personalDaysCount, otherDaysCount]);

  useEffect(() => {
    if (state?.firstTimeInfo?.selectedCardId) {
      setSelectedCardId(state?.firstTimeInfo?.selectedCardId);
    }
    dispatch({
      type: "firstTimeCurrentPage",
      firstTimeCurrentPage: "Checkout",
    });
  }, []);

  const validate = () => {
    let newFormErrors = { ...initialFormErrors };

    const noStrFrmt = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
    const alphabets = /^[A-Za-z]+$/;
    const emailRgx =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let onlyNumbersRgx = /^[0-9 ()+-]+$/;

    // FirstName

    if (firstName === "") {
      newFormErrors.firstName = "Enter First Name";
      newFormErrors.errorCounter++;
    }

    // LastName

    if (lastName === "") {
      newFormErrors.lastName = "Enter Last Name";
      newFormErrors.errorCounter++;
    }

    // Email
    if (email === "") {
      newFormErrors.email = "Enter email";
      newFormErrors.errorCounter++;
    } else if (!emailRgx.test(email)) {
      newFormErrors.email = "Incorrect Email";
      newFormErrors.errorCounter++;
    }
    if (!state.isLoggedIn) {
      if (confirmEmail === "") {
        newFormErrors.confirmEmail = "Enter Confirm email";
        newFormErrors.errorCounter++;
      } else if (!emailRgx.test(confirmEmail)) {
        newFormErrors.confirmEmail = "Incorrect Email";
        newFormErrors.errorCounter++;
      } else if (!state.isLoggedIn && email != confirmEmail) {
        newFormErrors.confirmEmail = "Email do not match";
        newFormErrors.errorCounter++;
      }
    }

    // Phone
    if (phone === "") {
      newFormErrors.phone = "Enter phone number";
      newFormErrors.errorCounter++;
    } else if (phoneLength === "") {
      newFormErrors.phone = "Enter phone number";
      newFormErrors.errorCounter++;
    } else if (phoneLength !== phone?.length) {
      newFormErrors.phone = "Enter valid phone number";
      newFormErrors.errorCounter++;
    }

    // Password
    if (!state.isLoggedIn) {
      let specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

      if (password === "") {
        newFormErrors.password = "Enter password";
        newFormErrors.errorCounter++;
      } else if (password.length < 8) {
        newFormErrors.password = "Password must be minimum 8";
        newFormErrors.errorCounter++;
      } else if (password.toLowerCase() == password) {
        newFormErrors.password =
          "Password must contain at least one capital letter";
        newFormErrors.errorCounter++;
      } else if (password.match(/\d+/g) == null) {
        newFormErrors.password = "Password must contain at least one number";
        newFormErrors.errorCounter++;
      } else if (!specialCharacters.test(password)) {
        newFormErrors.password =
          "Password must contain at least one special character";
        newFormErrors.errorCounter++;
      }

      if (confirmPassword === "") {
        newFormErrors.confirmPassword = "Enter confirm password";
        newFormErrors.errorCounter++;
      } else if (confirmPassword.length < 8) {
        newFormErrors.confirmPassword = "Confirm password must be minimum 8";
        newFormErrors.errorCounter++;
      } else if (confirmPassword.toLowerCase() == confirmPassword) {
        newFormErrors.confirmPassword =
          "Confirm Password must contain at least one capital letter";
        newFormErrors.errorCounter++;
      } else if (confirmPassword.match(/\d+/g) == null) {
        newFormErrors.confirmPassword =
          "Confirm Password must contain at least one number";
        newFormErrors.errorCounter++;
      } else if (password != confirmPassword) {
        newFormErrors.confirmPassword = "passwords do not match";
        newFormErrors.errorCounter++;
      } else if (!specialCharacters.test(confirmPassword)) {
        newFormErrors.confirmPassword =
          "Confirm Password must contain at least one special character";
        newFormErrors.errorCounter++;
      }
    }

    // Name
    if (firstName === "" || lastName === "") {
      newFormErrors.name = "Enter First Name and Last Name";
      newFormErrors.errorCounter++;
    }

    // Address
    if (address === "") {
      newFormErrors.address = "Enter Address";
      newFormErrors.errorCounter++;
    }

    // City
    if (city === "") {
      newFormErrors.city = "Enter City";
      newFormErrors.errorCounter++;
    }

    // State
    if (stateValue === "") {
      newFormErrors.stateValue = "Enter State";
      newFormErrors.errorCounter++;
    }

    // Zip Code
    if (zipCode === "") {
      newFormErrors.zipCode = "Enter Zip Code";
      newFormErrors.errorCounter++;
    } else if (zipCode?.length > 6) {
      newFormErrors.zipCode = "Zip Code Max 6 digits only";
      newFormErrors.errorCounter++;
    }

    // Country
    if (country === "") {
      newFormErrors.country = "Enter Country";
      newFormErrors.errorCounter++;
    }
    if (cards.length === 0) {
      newFormErrors.cardError = "Enter Card Details";
      newFormErrors.errorCounter++;
    }

    if (
      cards[0]?.card?.cardNumber === "" ||
      cards[0]?.card?.cardExpiry === "" ||
      cards[0]?.card?.cardCVC === ""
    ) {
      newFormErrors.cardError = "Enter Card Details";
      newFormErrors.errorCounter++;
    } else if (cardValidity === "notvalid") {
      newFormErrors.cardError = "Card is not valid";
      newFormErrors.errorCounter++;
    }

    setFormErrors(newFormErrors);
    if (newFormErrors.errorCounter == 0) {
      return true;
    } else {
      return false;
    }
  };

  const transactionFeesInfoClicked = () => {
    setIsTransactionFeesInfo(!isTransactionFeesInfo);
  };

  const addNewCreditCard = () => {
    let newCards = [...cards];
    let newAddedCard = {
      isNewCard: true,
      id: "Card_" + Math.random().toString(36).substr(2, 9),
      card: {
        cardNumber: "",
        cardExpiry: "",
        cardCVC: "",
      },
    };
    newCards.unshift(newAddedCard);
    setCards(newCards);

    let addedNewCreditCards = [...state.firstTimeInfo.addedNewCreditCards];
    addedNewCreditCards.unshift(newAddedCard);
    dispatch({
      type: "firstTimeInfo",
      firstTimeInfo: {
        ...state.firstTimeInfo,
        addedNewCreditCards: addedNewCreditCards,
      },
    });
  };
  const checkEmailExists = async (email: string) => {
    await axios({
      method: "POST",
      url: "/checkemail",
      data: { email },
    })
      .then((response) => {
        setShowEmailExists(true);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const logIn = async () => {
    Swal.fire({
      title: "Member Login",
      confirmButtonColor: "#D0A342",
      cancelButtonColor: "#d33",
      showCancelButton: false,
      confirmButtonText: '<a style="width:300px">Login<a>',
      showCloseButton: true,
      // customClass: {
      //   closeButton: 'checkout-email-login',
      // },
      buttonsStyling: true,
      footer:
        '<a href="/login" class="memberLoginForgotPassword" style="color:#D0A342"">Forgot Password?</a>',
      html: `
  <div>
  <img class="emailIcon" src="data:image/png;base64,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"/>
  <input type="email" id="email" class="swal2-input memberLoginInput" value=${email} placeholder=${email}></div>
    <div>
    <img class="passwordIcon" src="https://icons-for-free.com/iconfiles/png/512/lock+password+protect+safety+security+icon-1320086045132546966.png" />
    <input type="password" id="password" class="swal2-input memberLoginInput" className="email-alert-input" placeholder="Password">
   
  </div>`,
      focusConfirm: false,
      preConfirm: () => {
        const password = Swal.getPopup().querySelector("#password").value;
        if (!password) {
          Swal.showValidationMessage(`Please enter password`);
        }
        const email = Swal.getPopup().querySelector("#email").value;
        if (!email) {
          Swal.showValidationMessage(`Please enter email`);
        }
        return { email: email, password: password };
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const userData = {
          email: result?.value?.email,
          password: result?.value?.password,
        };
        await axios({
          method: "post",
          url: "/login",
          data: userData,
        })
          .then(async (response: any) => {
            setShowEmailExists(false);
            const responseCode = response.data.response.responseCode;
            const responseSession = response.data.response.session;
            const responseUserName = response.data.response.userName;
            if (response.data.message == "Success") {
              if (responseCode === "SMSSENT") {
                mfaVerification({
                  responseSession,
                  responseUserName,
                  email: userData.email,
                });
              }
              if (
                responseCode !== "SMSSENT" &&
                response.data.message === "Success"
              ) {
                cookieHandler("id", response.data.response.id);
                cookieHandler("tokenId", response.data.response.idToken);
                cookieHandler(
                  "refreshToken",
                  response.data.response.refreshToken
                );
                await getUserData(response.data.response.idToken);
              }

              // getUserDetails()
            }
          })
          .catch((err) => {
            logIn();
            // setShowEmailExists(false)
          });
      }
    });
  };

  const mfaVerification = async (data: any) => {
    Swal.fire({
      title: "Enter sms code for verification",
      confirmButtonColor: "#D0A342",
      cancelButtonColor: "#d33",
      showCancelButton: false,
      confirmButtonText: '<a style="width:300px">Verify<a>',
      showCloseButton: true,
      // customClass: {
      //   closeButton: 'checkout-email-login',
      // },
      buttonsStyling: true,
      html: `
  <div>
  <img class="emailIcon" src="data:image/png;base64,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"/>
  <input type="text" id="code" class="swal2-input memberLoginInput" placeholder="Enter verification code"></div>
    <div>
  </div>`,
      focusConfirm: false,
      preConfirm: () => {
        const code = Swal.getPopup().querySelector("#code").value;
        if (!code) {
          Swal.showValidationMessage(`Please enter verification code`);
        }
        return { code: code };
      },
    }).then(async (result: any) => {
      console.log(result?.value.code);
      const verificationData = {
        email: data.email,
        username: data.responseUserName,
        sessionValue: data.responseSession,
        mfaCode: result?.value.code,
      };
      await axios({
        method: "post",
        url: "/verifyuserlogin",
        data: verificationData,
      })
        .then(async (response: any) => {
          if (response.data.message === "Success") {
            cookieHandler("id", response.data.response.id);
            cookieHandler("tokenId", response.data.response.idToken);
            cookieHandler("refreshToken", response.data.response.refreshToken);
            await getUserData(response.data.response.idToken);
          }
          if (response.data.message === "Error") {
            console.log(response.data);
            Toast.fire({
              title: response.data.response.message
                ? response.data.response.message
                : "Invalid code or auth state for the user.",
              icon: "error",
            });
          }
        })
        .catch((err: any) => {
          console.log(err.response);
          Toast.fire({
            title: "Invalid verification code",
            icon: "error",
          });
        });
    });
  };

  const getUserData = async (tokenId: string) => {
    await axios({
      method: "post",
      url: "/getuser",
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    })
      .then((response) => {
        dispatch({ type: "userInfo", userInfo: response.data.response });
        dispatch({
          type: "isLoggedIn",
          isLoggedIn: true,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: "isLoggedIn",
          isLoggedIn: false,
        });
      });
  };
  const cardChangeHandler = (id: any, field: string, value: any) => {
    let newCards = [...cards];
    let index = newCards.findIndex((obj) => {
      return obj.id == id;
    });
    newCards[index].card[field] = value;
    setCards(newCards);

    if (newCards[index]?.isNewCard) {
      let newAddedCardIndex = state.firstTimeInfo.addedNewCreditCards.findIndex(
        (obj: { id: any }) => {
          return obj.id == id;
        }
      );
      let addedNewCreditCards = [...state.firstTimeInfo.addedNewCreditCards];
      addedNewCreditCards[newAddedCardIndex].card[field] = value;
      dispatch({
        type: "firstTimeInfo",
        firstTimeInfo: {
          ...state.firstTimeInfo,
          addedNewCreditCards: addedNewCreditCards,
        },
      });
    }
  };

  const removeNewCreditCard = (id: null) => {
    let newCards = [...cards];
    let index = newCards.findIndex((obj) => {
      return obj.id == id;
    });
    newCards.splice(index, 1);
    setCards(newCards);

    if (id == selectedCardId) {
      setSelectedCardId(null);
      dispatch({
        type: "firstTimeInfo",
        firstTimeInfo: { ...state.firstTimeInfo, selectedCardId: null },
      });
    }

    let newAddedCardIndex = state.firstTimeInfo.addedNewCreditCards.findIndex(
      (obj: { id: any }) => {
        return obj.id == id;
      }
    );
    let addedNewCreditCards = [...state.firstTimeInfo.addedNewCreditCards];
    addedNewCreditCards.splice(newAddedCardIndex, 1);
    dispatch({
      type: "firstTimeInfo",
      firstTimeInfo: {
        ...state.firstTimeInfo,
        addedNewCreditCards: addedNewCreditCards,
      },
    });
  };

  let cardBlocks = null;
  if (cards) {
    cardBlocks = cards.map((oneCard, index) => {
      let oneCardNumber;
      let oneCardExp;
      let oneCardCvc;

      if (oneCard.isNewCard) {
        oneCardNumber = oneCard.card.cardNumber;
        oneCardExp = oneCard.card.cardExpiry;
        oneCardCvc = oneCard.card.cardCVC;
      } else {
        oneCardNumber = "●●●● ●●●● ●●●● " + oneCard?.card?.last4;
        oneCardExp = oneCard?.card?.exp_month + "/" + oneCard?.card?.exp_year;
        oneCardCvc = "●●●";
      }
      //alert(selectedCardId)
      return (
        <div className="grid grid-cols-12 mt-3">
          {state.isLoggedIn ? (
            <div
              onClick={() => {
                setSelectedCardId(oneCard.id);
                // dispatch({
                //   type: "firstTimeInfo",
                //   firstTimeInfo: {
                //     ...state.firstTimeInfo,
                //     selectedCardId: oneCard.id,
                //   },
                // });
              }}
              className="radio-item"
            >
              <input
                className="col-span-1 self-center justify-self-center"
                checked={selectedCardId == oneCard.id ? true : false}
                type="radio"
                name={oneCard.id}
              />
              <label />
            </div>
          ) : null}
          {oneCard.isNewCard ? (
            <div
              className={
                state.isLoggedIn
                  ? "col-span-11 relative"
                  : "col-span-12 relative"
              }
            >
              {state.isLoggedIn ? (
                <span
                  onClick={() => removeNewCreditCard(oneCard.id)}
                  className="x -top-2 -right-2 z-30"
                ></span>
              ) : null}
              <CreditCardInput
                cardNumberInputProps={{
                  value: oneCardNumber,
                  onChange: (event: { target: { value: any } }) =>
                    cardChangeHandler(
                      oneCard.id,
                      "cardNumber",
                      event.target.value
                    ),
                }}
                cardExpiryInputProps={{
                  value: oneCardExp,
                  onChange: (event: { target: { value: any } }) =>
                    cardChangeHandler(
                      oneCard.id,
                      "cardExpiry",
                      event.target.value
                    ),
                }}
                cardCVCInputProps={{
                  value: oneCardCvc,
                  onChange: (event: { target: { value: any } }) =>
                    cardChangeHandler(
                      oneCard.id,
                      "cardCVC",
                      event.target.value
                    ),
                }}
                fieldStyle={{
                  width: "100%",
                  float: "right",
                  padding: "1rem",
                  backgroundColor: "#fafafa",
                  borderRadius: 2,
                  borderWidth: 1,
                }}
                inputStyle={{ backgroundColor: "#fafafa", fontSize: 14 }}
                dangerTextStyle={{ display: "none" }}
                containerStyle={{
                  width: "100%",
                  border: "1px solid #e5e7eb",
                  border: "none",
                }}
                invalidStyle={{
                  borderColor: "#e5e7eb",
                  borderRadius: "0.5rem",
                }}
              />
            </div>
          ) : (
            <div className="col-span-11">
              <div
                onClick={() => {
                  setSelectedCardId(oneCard.id);
                  dispatch({
                    type: "firstTimeInfo",
                    firstTimeInfo: {
                      ...state.firstTimeInfo,
                      selectedCardId: oneCard.id,
                    },
                  });
                }}
                className="grid grid-cols-10 w-full pl-4 rounded-lg py-3 mb-2 bg-lightGrey float-right bg-black text-xs md:text-base"
              >
                <span className="col-span-6 cursor-default">
                  {oneCardNumber}
                </span>
                <span className="col-span-2 cursor-default">{oneCardExp}</span>
                <span className="col-span-2 cursor-default">{oneCardCvc}</span>
              </div>
            </div>
          )}
        </div>
      );
    });
  }

  const normalizeInput = (value: string, previousValue: string | any[]) => {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;
    console.log("old phone format", currentValue);
    if (currentValue) setPhone(currentValue);
    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue;
      if (cvLength < 7)
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`;
    }
  };
  // console.log('phone in correct format', phone)
  return (
    <div>
      <div className="grid grid-cols-8 z-20 relative lg:gap-x-4 2xl:gap-x-12 page-content-main">
        <div className="lg:grid lg:grid-cols-2 col-span-8 xl:col-span-4 gap-x-2">
          <InputForm
            title="Email"
            type="email"
            id="email"
            value={email}
            onChange={(event: any) => {
              setShowEmailExists(false);
              setEmail(event.target.value);
              updateSignupInfo("email", event.target.value);
            }}
            onBlur={(event: any) =>
              !state.isLoggedIn ? checkEmailExists(event.target.value) : null
            }
            placeholder="Type your email"
            disabled={state.isLoggedIn}
            error={formErrors.email}
          />
          <button
            onClick={logIn}
            className={`${
              showEmailExists && "relative xl:absolute"
            } absolute text-left -top-4 xl:top-12 2xl:top-14 text-xs 2xl:text-sm text-camel`}
          >
            {!state.isLoggedIn && showEmailExists
              ? `Email already exists in our database. Click here to login.`
              : null}
          </button>
          {!state.isLoggedIn && (
            <InputForm
              title="Confirm Email"
              type="email"
              id="cemail"
              value={confirmEmail}
              onChange={(event: any) => {
                setConfirmEmail(event.target.value);
                updateSignupInfo("confirmEmail", event.target.value);
              }}
              placeholder="Confirm your email"
              disabled={state.isLoggedIn}
              error={formErrors.confirmEmail}
            />
          )}

          {/* <InputForm
            title="Phone"
            value={formattedPhone}
            id="phone"
            onChange={(event: any) => {
              setFormattedPhone((prevState) =>
                normalizeInput(event?.target?.value, prevState)
              );
            }}
            type="text"
            placeholder="Type your phone no"
            error={formErrors.phone}
          /> */}
          {!state.isLoggedIn && (
            <>
              <InputForm
                title="Password"
                value={password}
                id="password"
                onChange={(event: any) => setPassword(event.target.value)}
                type="password"
                placeholder="Type your password"
                error={formErrors.password}
              />
              <InputForm
                title="Confirm Password"
                value={confirmPassword}
                id="confirmPassword"
                onChange={(event: any) =>
                  setConfirmPassword(event.target.value)
                }
                type="password"
                placeholder="Confirm your password"
                error={formErrors.confirmPassword}
              />
            </>
          )}
          <div className="lg:pb-6 xl:pb-7 mb-6 lg:mb-0">
            <PhoneInput
              country={"us"}
              value={phone}
              //onChange={(phone) => setPhone(phone)}
              onChange={(value, country, e) => {
                setPhone(value);
                setPhoneLength(country.format.split(".").length - 1);
                updateSignupInfo("phone", value);
              }}
              containerClass="flex py-1 2xl:pb-2.5 2xl:pt-3 flex-wrap content-center border text-xs sm:text-sm 2xl:text-base rounded-lg bg-lightGrey2 focus:ring-gray-100 focus:outline-none placeholder-grey2 w-full z-20 h-full 2xl:h-auto"
              inputStyle={{ border: "none", backgroundColor: "transparent" }}
              buttonStyle={{ border: "none", backgroundColor: "transparent" }}
            />
            <span className="text-errorColor text-sm">
              {formErrors.phone ? formErrors.phone : null}
            </span>
          </div>

          {!state.isLoggedIn && <div></div>}
          <h3 className="font-PoppinsMedium text-black 2xl:text-xl xl:mb-6 mt-2">
            Payment Details
          </h3>
          <br />
          <div ref={ref}>
            <InputForm
              value={firstName}
              onChange={(event: any) => {
                setFirstName(event.target.value);
                updateSignupInfo("firstName", event.target.value);
              }}
              style={{ backgroundColor: "#fafafa" }}
              type="text"
              name="price"
              id="firstName"
              title="First Name"
              placeholder="Type your First Name"
              error={formErrors.firstName}
            />
          </div>
          <InputForm
            value={lastName}
            onChange={(event: any) => {
              setLastName(event.target.value);
              updateSignupInfo("lastName", event.target.value);
            }}
            style={{ backgroundColor: "#fafafa" }}
            type="text"
            name="price"
            id="lastName"
            title="Last Name"
            placeholder="Type your Last Name"
            error={formErrors.lastName}
          />
          <div className="col-span-2">
            <InputForm
              value={address}
              id="address"
              onChange={(event: any) => handleAddressSearch(event.target.value)}
              onKeyDown={(event: any) =>
                handleAddressSearch(event.target.value)
              }
              onBlur={(e: { relatedTarget: { id: string } }) => {
                if (e.relatedTarget?.id != "address") {
                  setPredictions([]);
                }
              }}
              title="Address"
              placeholder="Type your Address"
              error={formErrors.address}
            />
            {predictions?.length > 0 && (
              <div
                tabindex="0"
                id="address"
                className="absolute bg-white w-auto z-30 p-4 shadow-round mb-4 -mt-6"
              >
                <ul>
                  {predictions?.map((prediction) => (
                    <li key={prediction?.place_id}>
                      <button
                        id="address"
                        onClick={(e) =>
                          handlePredictionSelection(e, prediction)
                        }
                        onKeyDown={(e) =>
                          handlePredictionSelection(e, prediction)
                        }
                      >
                        {prediction?.description || "Not found"}
                      </button>
                    </li>
                  ))}
                </ul>
                <img
                  className="mt-4 w-28"
                  src="https://developers.google.com/maps/documentation/images/powered_by_google_on_white.png"
                  alt="Powered by Google"
                />
              </div>
            )}
          </div>
          <InputForm
            value={city}
            id="city"
            onChange={(event: any) => {
              setCity(event.target.value);
              updateSignupInfo("city", event.target.value);
            }}
            title="City"
            placeholder="Type your City"
            error={formErrors.city}
          />
          <InputForm
            value={stateValue}
            onChange={(event: any) => {
              setStateValue(event.target.value);
              updateSignupInfo("stateValue", event.target.value);
            }}
            id="state"
            title="State"
            placeholder="Type your State"
            error={formErrors.stateValue}
          />
          <InputForm
            value={zipCode}
            onChange={(event: any) => {
              setZipCode(event.target.value);
              updateSignupInfo("zipCode", event.target.value);
            }}
            id="zipCode"
            title="Zip Code"
            placeholder="Type your Zip Code"
            error={formErrors.zipCode}
          />
          <InputForm
            value={country}
            id="country"
            onChange={(event: any) => {
              setCountry(event.target.value);
              updateSignupInfo("country", event.target.value);
            }}
            title="Country"
            placeholder="Type your country"
            error={formErrors.country}
          />

          <div className="col-span-2">
            {/* <h3 className="font-PoppinsMedium text-black 2xl:text-xl mt-2 mb-3">
              Card Details
            </h3> */}
            {state.isLoggedIn ? (
              <p
                onClick={addNewCreditCard}
                className="inline-block text-black text-xs 2xl:text-sm underline mb-3 cursor-pointer"
              >
                + add a new credit card
              </p>
            ) : null}
            {cardBlocks}
            <span className="text-errorColor text-sm">
              {formErrors.cardError ? formErrors.cardError : null}
            </span>
          </div>
        </div>
        <div className="2xl:w-28rem w-full justify-self-center xl:justify-items-auto bg-white rounded-xl shadow-round px-4 md:px-10 py-5 col-span-8 xl:col-span-4 mt-6 xl:mt-0">
          <p className="font-bold text-black text-base 2xl:text-xl mb-2 font-PoppinsMedium">
            Summary
          </p>
          <p className="text-black text-sm 2xl:text-base mb-4 font-PoppinsMedium">
            Frequency:
            <span className="pl-2">
              {state.firstTimeInfo.donationFreq === "oneTime"
                ? "One Time"
                : "Recurring"}
            </span>
          </p>
          <div className="grid grid-cols-4">
            {summaryItems.map((summary: SummaryItem) => (
              <>
                <p className="mb-2 font-Poppins text-xs 2xl:text-base col-span-3">
                  {summary.label}
                </p>
                <p className="place-self-end mb-auto text-xs 2xl:text-base col-span-1">
                  X {summary.quantity}
                </p>
              </>
            ))}
          </div>
          <hr className="mb-4 mt-4" />
          {/* <div className='grid grid-cols-2'>
                <p className='text-black'>Total Donation</p><p className='place-self-end mb-auto text-black'>$1680.00</p>
                </div> */}
          <div className="grid grid-cols-4">
            <p className="mb-2 font-Poppins text-sm 2xl:text-base col-span-3 text-black">
              Total Donation Days
            </p>
            <p className="place-self-end mb-auto text-sm 2xl:text-base col-span-1 text-black">
              {islamicDaysQuantity + personalDaysQuantity + otherDaysQuantity}
            </p>
            <p className="mb-2 font-Poppins text-sm 2xl:text-base col-span-3 text-black">
              Donation Amount Per Selected Day
            </p>
            <p className="place-self-end mb-auto text-sm 2xl:text-base col-span-1 text-black">
              {/* ${(state?.firstTimeInfo?.donationTotal).toFixed(2)} */}
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(state?.firstTimeInfo?.donationTotal)}
            </p>
          </div>

          <div className="flex mt-3 text-sm 2xl:text-base cover-transaction-fee">
            <CheckBox
              setIsChecked={setTransactionFeeStatus}
              isChecked={coverTransactionFee}
              label="Cover Transaction Fees"
            />
            <div className="relative flex-auto ml-2">
              <InfoMsg
                isShown={isTransactionFeesInfo}
                text="Make your gift go further! Covering the transaction fees allows us to send your donation amount in full to the charity partners. The transaction fees include processing fees associated with the payment processor, fees charged by the payment processor for payouts to charities and a platform fee to cover expenses such as the domain, hosting, servers, cloud databases, storage, ongoing product improvements, UI/UX design, and web development."
              />
              <InfoCircle
                isInfoTextShown={isTransactionFeesInfo}
                toggleInfoText={setIsTransactionFeesInfo}
              />
            </div>
            <span className="flex-auto self-end text-right mb-auto text-sm 2xl:text-base text-black">
              {/* ${coverFee.toFixed(2)} */}
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(coverFee)}
            </span>
          </div>
          <hr className="mb-4 mt-4" />
          {
            <div className="grid grid-cols-4 mb-10">
              <span className=" text-sm 2xl:text-base col-span-3 text-black">
                Total Charge per Selected Day
                <br />
                <span>(to be charged as per schedule)</span>
              </span>
              <span className=" text-sm 2xl:text-base col-span-1 place-self-end mb-auto text-black">
                {/* $
                {(
                  state?.firstTimeInfo?.donationTotal +
                  (coverTransactionFee ? coverFee : 0)
                ).toFixed(2)} */}
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(
                  state?.firstTimeInfo?.donationTotal +
                    (coverTransactionFee ? coverFee : 0)
                )}
              </span>
            </div>
          }
          <div className="relative grid grid-cols-1 mb-10">
            <Button
              action={scheduleDontation}
              width="64"
              style="h-12 mx-auto shadow-camel hover:opacity-90"
              title="Schedule Donation"
              loading={loading}
              disableButton={disableButton}
            />
          </div>
          <div className="text-center">
            <p className="text-sm md:text-base text-center m-0 text-black">
              <span className="relative quote-text-cnt">
                <img
                  className="absolute md:-left-12 -left-6 -top-7 w-7 md:w-12 quote-img"
                  src={Quotes}
                />
                “Charity does not decrease wealth…”
              </span>
            </p>
            <p className="text-sm md:text-base font-black  m-0 text-black">
              <span className="text-camel">-</span> Prophet Muhammad ﷺ
            </p>
          </div>
        </div>
      </div>

      <div className="flex mt-12 z-20 relative  text-sm 2xl:text-base">
        <CheckBox
          setIsChecked={setIsTermsAndPrivacy}
          isChecked={isTermsAndPrivacy}
          labelWithJsx={`By clicking Schedule Donation, you agree to 
          the CharityMoments <a class="underline text-camel" target="_blank" href="/terms-and-conditions">Terms and Conditions</a> 
          and CharityMoments <a class="text-camel underline" target="_blank" href="/privacy-policy">Privacy Policy</a>.`}
        />
      </div>
      <p className="clear-both text-black mt-10  text-sm 2xl:text-base">
        If you want tax deductible receipts for your charitable contributions,
        we need your consent to share your data with the charity partners.
      </p>
      <div className="flex mt-6 z-20 relative  text-sm 2xl:text-base">
        <CheckBox
          setIsChecked={setIsConsent}
          isChecked={consent}
          label="Yes, I give my consent to CharityMoments."
        />
      </div>

      {/* Donation Schedule dropdown */}
      <div
        className="shadow-round3 mt-6 py-2 transform translate-y-4 bg-white rounded-xl font-bold z-30 relative toggle-schedule-view"
        onClick={toggleScheduleView}
        style={{ cursor: "pointer" }}
      >
        <span className="font-PoppinsMedium font-medium cursor-default ml-6  text-sm 2xl:text-base">
          View Your Donation Schedule
        </span>
        <div className="bg-camel rounded-full mr-4">
          {height !== 0 ? (
            <VscChevronUp className="text-white" />
          ) : (
            <VscChevronDown className="text-white" />
          )}
        </div>
      </div>

      <AnimateHeight duration={500} height={height}>
        <div className="bg-lightGrey rounded-lg border p-3 md:p-6 inline-block w-full z-20 relative md:pt-10 pt-8 don-sch-block-main">
          <IslamicDaysBlock
            setPage={props.setPage}
            viewName="Islamic Days"
            islamicDays={state?.firstTimeInfo?.islamicDays}
            amountPerDay={(
              state?.firstTimeInfo?.donationTotal +
              (coverTransactionFee ? coverFee : 0)
            ).toFixed(2)}
          />
          <PersonalDaysBlock
            setPage={props.setPage}
            viewName="Personal Days"
            personalDays={state?.firstTimeInfo?.personalDays}
            amountPerDay={(
              state?.firstTimeInfo?.donationTotal +
              (coverTransactionFee ? coverFee : 0)
            ).toFixed(2)}
          />
          {state?.firstTimeInfo?.donationFreq === "recurring" && (
            <OtherDaysBlock
              setPage={props.setPage}
              viewName="Sunnah Days"
              otherDays={state?.firstTimeInfo?.otherDays}
              amountPerDay={(
                state?.firstTimeInfo?.donationTotal +
                (coverTransactionFee ? coverFee : 0)
              ).toFixed(2)}
            />
          )}
        </div>
      </AnimateHeight>
    </div>
  );
}

const IslamicDaysBlock = (props: any) => {
  const { state, dispatch } = useContext(Context);
  const [monthData, setmonthsData] = useState(null);

  useEffect(() => {
    axios
      .get("/islamicmonths")
      .then((response) => {
        setmonthsData(response.data.response);
      })
      .catch((err) => console.log(err));
  }, []);

  const isNothingSelected = () => {
    let nothingSelected = true;
    props?.islamicDays?.forEach((day: { isIslamicDaySelected: any }) => {
      if (day.isIslamicDaySelected) {
        nothingSelected = false;
      }
    });
    return nothingSelected;
  };

  if (monthData) {
    let dayBlocks = null;
    dayBlocks = props?.islamicDays?.map(
      (day: {
        islamicMonthId: any;
        isIslamicDaySelected: any;
        _id: any;
        dayOfMonth: any;
        name: any;
      }) => {
        let monthIndex = monthData?.findIndex((obj: { _id: any }) => {
          if (obj._id === day.islamicMonthId) {
            return true;
          }
        });
        let monthName = monthData[monthIndex]?.name;
        if (day.isIslamicDaySelected)
          return (
            <DayBlock
              dayType={"islamicDays"}
              removeIconShown={true}
              id={day._id}
              isIslamicDays={true}
              dayOfMonth={day.dayOfMonth}
              monthName={monthName}
              dayName={day.name}
              amountPerDay={props.amountPerDay}
            />
          );
      }
    );

    return (
      <div className="relative z-20 rounded-lg float-left bg-camel mb-4 -p-1 mr-0 md:mr-6 w-full xl:w-72 2xl:w-80 md:w-full dontation-schedule-block">
        <p className="inline-block pl-6 py-2 font-normal text-white">
          {props.viewName}
        </p>
        <div
          onClick={() =>
            dispatch({
              type: "firstTimeCurrentPage",
              firstTimeCurrentPage: "SelectIslamicDays",
            })
          }
          className="cursor-pointer float-right mr-5 mt-2 inline-block rounded-md bg-white px-6 md:py-1 cursor-default"
        >
          <span className="font-normal text-camel">Add</span>
        </div>
        <div className="bg-white h-auto py-4 rounded-lg md:px-6 px-4">
          {!isNothingSelected() ? (
            dayBlocks
          ) : (
            <p className="my-6 font-normal">Nothing Selected</p>
          )}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

const PersonalDaysBlock = (props: any) => {
  const { state, dispatch } = useContext(Context);

  const isNothingSelected = () => {
    let nothingSelected = true;
    props?.personalDays?.forEach(
      (day: { isPersonalDayActive: any; date: any }) => {
        if (day.isPersonalDayActive && day.date) {
          nothingSelected = false;
        }
      }
    );
    return nothingSelected;
  };

  let dayBlocks = null;
  dayBlocks = props?.personalDays?.map(
    (day: {
      isPersonalDayActive: any;
      date: any;
      _id: any;
      manualEntryText: any;
      name: any;
    }) => {
      if (day.isPersonalDayActive && day.date) {
        return (
          <DayBlock
            dayType={"personalDays"}
            removeIconShown={true}
            id={day._id}
            manualEntryText={day?.manualEntryText ? day?.manualEntryText : null}
            isPersonalDays={true}
            date={day?.date ? day?.date : null}
            dayName={day.name}
            amountPerDay={props.amountPerDay}
          />
        );
      }
    }
  );

  return (
    <div className="relative z-20 rounded-lg float-left bg-camel mb-4 -p-1 mr-0 md:mr-6 w-full xl:w-72 2xl:w-80 md:w-full dontation-schedule-block">
      <p className="inline-block pl-6 py-2 font-normal text-white">
        {props.viewName}
      </p>
      <div
        onClick={() =>
          dispatch({
            type: "firstTimeCurrentPage",
            firstTimeCurrentPage: "SelectPersonalDays",
          })
        }
        className="cursor-pointer float-right mr-5 mt-2 inline-block rounded-md bg-white px-6 md:py-1 cursor-default"
      >
        <span className="font-normal text-camel">Add</span>
      </div>
      <div className=" bg-white rounded-md"></div>
      <div className="bg-white h-auto py-4 rounded-lg md:px-6 px-4">
        {!isNothingSelected() ? (
          dayBlocks
        ) : (
          <p className="my-6 font-thin">Nothing Selected</p>
        )}
      </div>
    </div>
  );
};

const OtherDaysBlock = (props: any) => {
  const { state, dispatch } = useContext(Context);
  const isNothingSelected = () => {
    let nothingSelected = true;
    props?.otherDays?.forEach((day: { isSelected: any }) => {
      if (day.isSelected) {
        nothingSelected = false;
      }
    });
    return nothingSelected;
  };

  let dayBlocks = null;
  dayBlocks = props?.otherDays?.map(
    (day: { isSelected: any; name: any; numberOfDays: any; _id: any }) => {
      if (day.isSelected) {
        return (
          <DayBlock
            dayType="otherDays"
            name={day.name}
            numberOfDays={day.numberOfDays}
            isSelected={day.isSelected}
            id={day._id}
            removeIconShown={true}
            amountPerDay={props.amountPerDay}
          />
        );
      }
    }
  );

  return (
    <div className="relative z-20 rounded-lg float-left bg-camel mb-4 -p-1 mr-0 md:mr-6 w-full xl:w-72 2xl:w-80 md:w-full dontation-schedule-block">
      <p className="inline-block pl-6 py-2 font-normal text-white">
        {props.viewName}
      </p>
      <div
        onClick={() =>
          dispatch({
            type: "firstTimeCurrentPage",
            firstTimeCurrentPage: "SelectIslamicDays",
          })
        }
        className="cursor-pointer float-right mr-5 mt-2 inline-block rounded-md bg-white px-6 md:py-1 cursor-default"
      >
        <span className="font-normal text-camel">Add</span>
      </div>
      <div className=" bg-white rounded-md"></div>
      <div className="bg-white h-auto py-4 rounded-lg md:px-6 px-4">
        {!isNothingSelected() ? (
          dayBlocks
        ) : (
          <p className="my-6 font-thin">Nothing Selected</p>
        )}
      </div>
    </div>
  );
};

function dynamicSum({ data, sumKey }: any) {
  // const filteredArray = data.filter((i:any) => i[validatorKey] === id);
  const filteredSum: number = data.reduce(
    (a: number, b: any) => a + (b[sumKey] ? parseInt(b[sumKey], 10) : 0),
    0
  );
  return filteredSum;
}
